/* Builder step 1 · « Que voulez-vous obtenir ? » — the four objective tiles (merchant-experience review
   08/10 D.1 + E1; campaign-system review D.1 adds « Un cadeau, simplement »). A tile PREFILLS visit 1's
   demande and replaces nothing: the tile already on does nothing, and « Le moment » (D-83/D-87/D-88) stays
   the one card where the order is chosen (merchant-experience vet: tiles prefill, never replace). The tile
   on is read back from visit 1's demande, so a draft, a campaign under « Modifier » and a demande picked
   by hand all show the right tile with nothing stored. */
import { blankDemande, type Demande, type PlatformId, type SocialId } from '@/lib/campaign'
import type { Ask } from '@/lib/asks'

export type Objectif = 'avis' | 'abonnes' | 'connaitre' | 'cadeau'
export const OBJECTIFS: { id: Objectif; title: string; line: string }[] = [
  { id: 'avis', title: 'Plus d’avis', line: 'Une invitation vers votre fiche, toujours passable.' },
  { id: 'abonnes', title: 'Plus d’abonnés', line: 'Instagram, Facebook ou TikTok.' },
  { id: 'connaitre', title: 'Mieux connaître mes clients', line: 'Un quiz, une question ou un retour privé.' },
  { id: 'cadeau', title: 'Un cadeau, simplement', line: 'La roue et le cadeau, sans demande.' },
]

export const objectifOf = (d: Demande): Objectif =>
  d.kind === 'avis' ? 'avis' : d.kind === 'suivre' ? 'abonnes' : d.kind === 'rien' ? 'cadeau' : 'connaitre'

/** The demande a tile fills visit 1 with: the first linked platform (Google comes from the fiche), the
 *  first linked network, the first quiz — else question, else retour privé — of the library, or nothing.
 *  `null` = the tile is already the one on: keep the merchant's demande as it is. */
export function demandeFor(o: Objectif, current: Demande, ctx: { platforms: PlatformId[]; socials: SocialId[]; asks: Ask[] }): Demande | null {
  if (objectifOf(current) === o) return null
  if (o === 'avis') return blankDemande('avis', ctx.platforms.includes('google') || !ctx.platforms.length ? 'google' : ctx.platforms[0])
  if (o === 'abonnes') return { kind: 'suivre', platforms: [], askId: null, gift: { mode: 'roue' }, social: ctx.socials[0] ?? 'instagram' }
  if (o === 'cadeau') return { kind: 'rien', platforms: [], askId: null, gift: { mode: 'roue' } }
  const a = (['quiz', 'question', 'retour'] as const).map(k => ctx.asks.find(x => x.kind === k)).find(Boolean)
  return { kind: a ? a.kind as Demande['kind'] : 'quiz', platforms: [], askId: a?.id ?? null, gift: { mode: 'roue' } }
}
